 <div *ngIf="!isOnline" class="offline-overlay">
    <div class="offline-message">
      <div class="wifi" ></div>
    </div>
    <h1 style="font-size: 2.5rem; color: #333;">You're Offline</h1>
    <p style="font-size: 1.1rem; color: #555; max-width: 400px; margin-top: 10px;">
      It looks like your internet connection is lost. Please reconnect to continue exploring <strong>Medworld Expo</strong>.
    </p>
  </div>
  
<app-spinner></app-spinner>
<router-outlet *ngIf="isOnline"></router-outlet>
